import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationRolesAndPermissionListResponse,
  IConfigurationRolesAndPermissionListResponseData,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setStaffRolesList } from "@/app_redux/reducers/slices/auth/configuration_slice";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationRBACUserRolesAndPermissionListAPI = () => {
  const [rolesAndPermissionList, setRolesAndPermissionList] =
    useState<IConfigurationRolesAndPermissionListResponseData[]>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response: IConfigurationRolesAndPermissionListResponseData[] = await axios
        .get(`${CONFIGURATION_APIS?.GET_ROLES_AND_PERMISSION_LIST?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IConfigurationRolesAndPermissionListResponse>) => {
          if (res.data.status === true) {
            setRolesAndPermissionList(res.data.data);
            dispatch(
              setStaffRolesList({
                data: res.data.data,
              }),
            );
            return res.data.data;
          } else {
            toast.error("Error while fetching service details.");
            return null;
          }
        })
        .catch((e: AxiosError) => {
          captureError(e)
          sendCurl(e.config["curlCommand"]);
          return null;
        });
      return response;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axiosError.code === "ERR_BAD_REQUEST") {
          toast.error("Error at server while fetching city details.");
        }
        if (axiosError.response?.status === 400) {
          toast.error(axiosError.message);
        }
        if (axiosError.response?.status === 500) {
          toast.error("Internal Server Error, Contact Tech Team.");
        }
      } else {
        toast.error("Server Error: " + error.message);
      }
      return null;
    }
  }, [dispatch, configuration]);

  return { rolesAndPermissionList, execute };
};
